import React from 'react'

import { icon as getIconDefinition, IconDefinition, IconParams } from '@fortawesome/fontawesome-svg-core'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export type BaseIconProps<P extends Record<string, unknown>> = SvgIconProps & P & { params?: IconParams }

export type OwnProps = {
  icon: IconDefinition
}

export type IconProps = BaseIconProps<OwnProps>

export const StyledSvgIcon = styled(SvgIcon)`
`

export const Icon: React.FC<IconProps> = ({ icon: iconLookup, params, ...props }) => {
  const def = getIconDefinition(iconLookup, params)

  if (!def) {
    return null
  }

   
  const [width, height, _ligature, _unicode, path] = def.icon

  return (
    <StyledSvgIcon {...props} viewBox={`0 0 ${width} ${height}`}>
      {
        Array.isArray(path) ? path.map((p, i) => <path key={i} d={p} />) : <path d={path} />
      }
    </StyledSvgIcon>
  )
}
